import { render } from "./DanhSachVatTuTable.vue?vue&type=template&id=62a87d0c&ts=true"
import script from "./DanhSachVatTuTable.vue?vue&type=script&lang=ts"
export * from "./DanhSachVatTuTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__